export default {
  title: 'Artikelen',
  order_note: 'Opmerking bij bestelling',
};
